import { FAQCategory } from '../types/faq';
import { HelpCircle, RefreshCw, Scale, Headphones } from 'lucide-react';

export const faqCategories: FAQCategory[] = [
  {
    title: "Student Status Verification",
    icon: HelpCircle,
    questions: [
      {
        question: "How can I verify my student status?",
        answer: "1. Go to the **My Information** page via [your client area](https://my.europeanstudent.org/clientarea.php?action=details)\n2. Click on the **\"Verification form not visible\"** button\n3. Fill out the verification form by uploading a valid document proving your student status"
      },
      {
        question: "What documents are accepted for verification?",
        answer: "The accepted documents for verification are listed in our [official document](https://europeanstudent.org/docs/cgu.pdf). These include:\n\n- Valid student ID cards\n- Current year enrollment certificates"
      },
      {
        question: "How long does verification take?",
        answer: "The processing time for your verification can take a few hours to a few days. You will receive a notification once your status is validated."
      }
    ]
  },
  {
    title: "Renewals and Orders",
    icon: RefreshCw,
    questions: [
      {
        question: "How can I renew my access or services?",
        answer: "1. Log in to [your client area](https://my.europeanstudent.org/clientarea.php?action=details)\n2. Follow the verification process\n3. Upload your updated documents"
      },
      {
        question: "What should I do if an offer is out of stock?",
        answer: "If an offer like Canva Pro is out of stock, please wait for the next restock. You can:\n\n- Reorder via [our store](https://my.europeanstudent.org/store/canva)\n- Follow our updates on Instagram [@europeanstudent](https://instagram.com/europeanstudent)"
      }
    ]
  },
  {
    title: "Help & Support",
    icon: Headphones,
    questions: [
      {
        question: "How can I contact support if I have an issue?",
        answer: "If you encounter any issues, you can contact us via our support page on the website or write to us directly from your personal space."
      },
      {
        question: "How can I stay updated with news and updates?",
        answer: "Stay informed about our latest updates through:\n\n- Our Instagram account [@europeanstudent](https://instagram.com/europeanstudent)\n- Our official communication channel"
      }
    ]
  },
  {
    title: "Service Usage",
    icon: Scale,
    questions: [
      {
        question: "How do I access my services after verification?",
        answer: "1. Log in to your client area\n2. Access your services\n3. Complete your orders if necessary"
      },
      {
        question: "Can I use the services on multiple devices?",
        answer: "Yes, you can use our services on different devices by simply logging into your account."
      }
    ]
  }
];